import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu']

  open() {
    this.menuTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.menuTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }
}
